import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    CALCULATE_LOAN,
} from "./actionTypes.js";

import {
    calculateLoanSuccess,
    calculateLoanFail,
} from "./actions.js";

import { loanCalculateApi } from "./loanCalculatorApi.js";

function* fetchLoanCalculateResult({ payload }) {
    try {
        const response = yield call(loanCalculateApi, payload);
        yield put(calculateLoanSuccess(response));
    } catch (error) {
        yield put(calculateLoanFail(error));
    }
}

function* LoanCalculateSaga() {
    yield takeEvery(CALCULATE_LOAN, fetchLoanCalculateResult);
}

export default LoanCalculateSaga